import { render, staticRenderFns } from "./nextPostBtn.vue?vue&type=template&id=4cdff8e8"
import script from "./nextPostBtn.vue?vue&type=script&lang=js"
export * from "./nextPostBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports